import { useCallback, useState } from 'react';
import { useShallowRouter } from '@components/Hooks/useRouter';
import { updateQueryParams } from '@utils/route';
import { useExperiments } from '@wix/fe-essentials-standalone';
import { ENABLE_TEMPLATE_MARKETPLACE_SEARCH } from '@utils/constants';
import { DropdownLayoutOption } from '@wix/design-system';
import {
  TEMPLATES_BI_CLICK_TYPES,
  useTemplatesBi,
} from '@components/Hooks/useTemplatesBi';

const MAX_LENGTH_SEARCH_TERM = 100;

const useTemplateSearchField = () => {
  const { experiments } = useExperiments({ readOnly: true });
  const isSearchEnabled =
    experiments.get(ENABLE_TEMPLATE_MARKETPLACE_SEARCH) === 'B';
  const { logBiClick } = useTemplatesBi({});

  const [searchInputValue, setSearchInputValue] = useState<string>('');
  const { navigate, router } = useShallowRouter();

  const onSearch: React.KeyboardEventHandler<HTMLInputElement> = useCallback(
    (_e) => {
      const searchTerm =
        typeof searchInputValue === 'string'
          ? searchInputValue?.trim().substring(0, MAX_LENGTH_SEARCH_TERM)
          : '';
      if (!searchTerm) {
        return;
      }
      logBiClick({
        click_type: TEMPLATES_BI_CLICK_TYPES.searchBar,
        click_data: searchTerm,
      });
      navigate(
        updateQueryParams(
          { search: searchTerm, sort: 'relevance' },
          router,
          {},
          {
            search: true,
          },
        ),
      );
    },
    [searchInputValue, router, logBiClick],
  );

  const onSelect = useCallback(
    (option: DropdownLayoutOption) => {
      const searchTerm = String(option?.value);
      logBiClick({
        click_type: TEMPLATES_BI_CLICK_TYPES.searchBarMostPopular,
        click_data: searchTerm,
      });
      navigate(
        updateQueryParams(
          { search: searchTerm, sort: 'relevance' },
          router,
          {},
          {
            search: true,
          },
        ),
      );
    },
    [router, logBiClick],
  );

  const clearSearchInputValue = useCallback(() => {
    setSearchInputValue('');
  }, []);

  return {
    onSearch,
    onSelect,
    setSearchInputValue,
    clearSearchInputValue,
    searchInputValue,
    isSearchEnabled,
  };
};

export default useTemplateSearchField;
